import { render } from "./JourneyLegsEditor.vue?vue&type=template&id=5c56e09e"
import script from "./JourneyLegsEditor.vue?vue&type=script&lang=js"
export * from "./JourneyLegsEditor.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/gestionale-simba-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__